import { action, atom, reatomBoolean } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { PlatformUtil, STORAGE_PREFIX } from '@root/shared'

import type { UnsafeUrlProvider } from '../model'

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/skipUnsafeUrlWarning`

// eslint-disable-next-line @reatom/unit-naming-rule
export const unsafeUrlDialogEvent = action<[string | URL, UnsafeUrlProvider]>(
  'unsafeUrlDialogEvent',
)

unsafeUrlDialogEvent.onCall((ctx, _, data) => {
  const [[unsafeUrl, unsafeUrlProvider]] = data

  const skipWarning = ctx.get(skipUnsafeUrlWarningAtom)

  if (skipWarning) {
    PlatformUtil.openLink(unsafeUrl, '_blank')
  } else {
    unsafeUrlDialogAtom(ctx, { unsafeUrl, unsafeUrlProvider })
  }
})

export const skipUnsafeUrlWarningAtom = reatomBoolean(
  false,
  'skipUnsafeUrlWarningAtom',
).pipe(withLocalStorage(STORAGE_KEY))

export const unsafeUrlDialogAtom = atom<
  | {
      unsafeUrl: string | URL
      unsafeUrlProvider: UnsafeUrlProvider
    }
  | undefined
>(undefined, 'unsafeUrlDialogAtom')
